module.exports = __webpack_public_path__ + "2.bbdda5d8.png";